import { useEffect } from "react";

import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import FormRow from "components/form/FormRow";

import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";

import NGV from "..";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function NGVEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(NGV, tipo, TipoClass);

    const [apontamento] = useFieldValue();

    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = NGV.calcConformidade(apontamento, params);
            form.change("coletas", apontamento.coletas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} TipoClass={TipoClass} showVariedade />

            <ApontamentoAmostraParams>
                <FormRow>
                    <TextInput name="insumo" label="Variedade" />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="I. G. V. (Un.):">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="M. P. A. (m):">{params.metroPontoAvaliado}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="qtdGemas" label="Qtd. Gemas Viáveis" />
                <TextInput type="number" name="qtdGemasMetro" label="Qtd. Gemas p. M" disabled />
                <TextInput name="conforme" label="Conforme" disabled />

                <TextInput type="number" name="danosPragasClima" label="Danos Pragas/Clima" />
                <TextInput type="number" name="danosMecanico" label="Danos Mecânico" />

                {/* Adicionar o total da soma de (pragas/clima + Danos Mecânico + Qtd. Gemas Viáveis). */}
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput
                        sx={{ "& input": { fontWeight: "bold" } }}
                        name="totalGemas"
                        label={"Total de Gemas Viáveis"}
                        disabled
                    />
                </FormRow>
                <FormRow>
                    <TextInput sx={{ "& input": { fontWeight: "bold" } }} name="total" label={"Total"} disabled />
                </FormRow>
            </ApontamentoResultado>
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
